import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const errorMessages = {
  invalid_login_state: "This sign-in request could not be verified. Please start again.",
  login_state_expired: "This sign-in request expired. Please start again.",
  invalid_login_nonce: "This sign-in request could not be verified. Please start again.",
  id_token_is_required: "Apple did not return the information needed to sign you in.",
  invalid_token_payload: "Apple returned incomplete sign-in information.",
  email_required_for_new_account: "Apple did not share an email address needed to create your account.",
  apple_signin_failed: "Apple Sign-In could not be completed. Please try again.",
};

function AppleCallback({ onComplete }) {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fragmentParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const isLoginAttempt = params.get("is_login_attempt");
    const success = params.get("success");
    const exchangeCode = fragmentParams.get("exchange_code");
    const state = params.get("state");
    const errorCode = params.get("error");

    if (isLoginAttempt !== "true") {
      navigate("/", { replace: true });
      return;
    }

    if (success === "true" && exchangeCode && state) {
      onComplete({ exchangeCode, state }).catch((completionError) => {
        console.error("Apple callback completion failed:", completionError);
        setError(completionError.message || "Apple Sign-In could not be completed. Please try again.");
      });
      return;
    }

    setError(errorMessages[errorCode] || "Apple Sign-In could not be completed. Please try again.");
  }, [navigate, onComplete]);

  if (!error) {
    return (
      <main className="auth-callback-page" aria-live="polite">
        <span className="spinner" aria-hidden="true" />
        <h1>Signing you in…</h1>
        <p>Securely completing your Apple sign-in.</p>
      </main>
    );
  }

  return (
    <main className="auth-callback-page">
      <h1>Apple Sign-In didn’t finish</h1>
      <p>{error}</p>
      <button type="button" className="button button-primary" onClick={() => navigate("/", { replace: true })}>
        Return to sign in
      </button>
    </main>
  );
}

export default AppleCallback;
